import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!userInfo) {
    // Kullanıcı giriş yapmamışsa, onu login sayfasına yönlendir.
    // Nereden geldiği bilgisini (location) de state ile gönderiyoruz ki,
    // giriş yaptıktan sonra kaldığı yerden devam edebilsin (isteğe bağlı).
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Kullanıcı giriş yapmışsa, istenen sayfayı (children) göster.
  return children;
};

export default ProtectedRoute;